import { isPresent } from './any';
/**
 * Numeric module.
 * @module src/numeric
 */

/**
 * Returns if a number is between 2 other number including boundary.
 *
 * @function isBetween
 *
 * @param {number} value - The value to be tested
 * @param {number} minValue - The value where the interval starts
 * @param {number} maxValue - The value where the interval ends
 * @return {boolean} value is or not between the interval
 *
 * @example
 * isBetween(1, 1, 10);
 * // returns true
 *
 * @example
 * isBetween(10, 1, 10);
 * // returns true
 *
 * @example
 * isBetween(6, 1, 10);
 * // returns true
 *
 * @example
 * isBetween(0, 1, 10);
 * // returns false
 *
 * @example
 * isBetween(11, 1, 10);
 * // returns false
 *
 */

export const isBetween = (value, minValue, maxValue) => {
  return value >= minValue && value <= maxValue;
};
/**
 * Returns if a number is integer or not.
 *
 * @function isInteger(number)
 *
 * @param {Number|String} number - The value to be tested
 * @return {boolean} value is or not integer
 *
 * @example
 * isInteger();
 * // returns false
 *
 * @example
 * isInteger('');
 * // returns false
 *
 * @example
 * isInteger('1a');
 * // returns false
 *
 * @example
 * isInteger('1.3');
 * // returns false
 *
 * @example
 * isInteger('1');
 * // returns true
 *
 **/

export const isInteger = string => isPresent(string) && Number.isInteger(Number(string));
/**
 * Returns if a number isEven or not.
 *
 * @function isEven
 *
 * @param {Number|String} number - The value to be tested
 * @return {boolean} value is or not even
 *
 * @example
 * isEven(10);
 * // returns true
 *
 * @example
 * isEven('10');
 * // returns true
 *
 * @example
 * isEven(10.0);
 * // returns true
 *
 * @example
 * isEven('10.0');
 * // returns true
 *
 * @example
 * isEven('10,0');
 * // returns false
 *
 * @example
 * isEven('10.1');
 * // returns false
 *
 * @example
 * isEven(10.1);
 * // returns false
 *
 * @example
 * isEven(11);
 * // returns false
 *
 */

export const isEven = number => isInteger(number) && number % 2 === 0;
/**
 * Returns if a number isOdd or not.
 *
 * @function isOdd
 *
 * @param {Number|String} number - The value to be tested
 * @return {boolean} value is or not odd
 *
 * @example
 * isOdd(11);
 * // returns true
 *
 * @example
 * isOdd('11');
 * // returns true
 *
 * @example
 * isOdd(11.0);
 * // returns true
 *
 * @example
 * isOdd('11.0');
 * // returns true
 *
 * @example
 * isOdd('11,0');
 * // returns false
 *
 * @example
 * isOdd('11.1');
 * // returns false
 *
 * @example
 * isOdd(11.1);
 * // returns false
 *
 * @example
 * isOdd(10);
 * // returns false
 *
 */

export const isOdd = number => isInteger(number) && number % 2 === 1;